import {
  type UserSubOrderV2,
  UserSubOrderV2EnrichedStatusEnum,
} from '@redteclab/api/clients/bully'

import { userSubOrderAccessorIsCancellationRequested } from './userSubOrderAccessor'

type SubOrderReturnLabelSelfServiceAvailability = 'enabled' | 'hidden'

export const subOrderStatusAccessorGetReturnLabelSelfServiceAvailability = (
  subOrder: UserSubOrderV2,
): SubOrderReturnLabelSelfServiceAvailability => {
  if (userSubOrderAccessorIsCancellationRequested(subOrder)) {
    return 'hidden'
  }

  const returnLabel = subOrder.returnInfo?.label
  const hasActiveReturnLabel = Boolean(returnLabel && !returnLabel.expired)
  const hasNoReturnShipments = !subOrder.returnInfo?.shipments?.length
  const isEligibleStatus =
    subOrder.enrichedStatus === UserSubOrderV2EnrichedStatusEnum.Dispatched ||
    subOrder.enrichedStatus === UserSubOrderV2EnrichedStatusEnum.ReadyForPickup

  return isEligibleStatus &&
    hasActiveReturnLabel &&
    hasNoReturnShipments &&
    subOrder.subOrderId
    ? 'enabled'
    : 'hidden'
}
